<template>
  <div>
    <bs-page-title :titleLabel="'ポイント集計単位マスタ編集'" :btnLabel="''"></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">{{ alertMessage }}</bs-msg-alert>

    <div class="row mb-3">
      <div class="col-2 mb-2">
        <p class="text-center py-1 fs-6">単位コード</p>
      </div>
      <div class="col-4 mb-2">
        <input
          type="text"
          class="form-control"
          v-model="formData.unit_code"
          :disabled="isEdit"
        />
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-2 mb-2">
        <p class="text-center py-1 fs-6">単位名</p>
      </div>
      <div class="col-4 mb-2">
        <input
          type="text"
          class="form-control"
          v-model="formData.unit_name"
        />
      </div>
    </div>

    <div class="row">
      <div class="col text-center">
        <button class="btn btn-primary me-2" @click="save_data">
          保存
        </button>
        <button class="btn btn-secondary" @click="go_back">
          戻る
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BsPageTitle from '../../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../../atoms/BsMsgAlert.vue'
import config from '@/const'

export default {
  name: 'PointUnitEditView',
  data: function () {
    return {
      alertMessage: '',
      alertClass: 'alert-info',
      formData: {
        id: null,
        unit_code: '',
        unit_name: ''
      },
      isEdit: false
    }
  },
  components: {
    BsPageTitle,
    BsMsgAlert
  },
  computed: {
    ...mapState({})
  },
  methods: {
    async load_data() {
      const id = this.$route.params.id
      if (id) {
        this.isEdit = true
        try {
          const params = {
            master_type: 'point_unit',
            id: id
          }

          await this.basicPosts_S(config.BASE_API_URL + '/master/detail', params)
            .then(response => {
              if (response.data && response.data.body) {
                this.formData = response.data.body
              } else {
                this.alertMessage = 'データの取得に失敗しました'
                this.alertClass = 'alert-danger'
              }
            })
            .catch(error => {
              console.error('データの取得に失敗しました:', error)
              this.alertMessage = 'データの取得に失敗しました'
              this.alertClass = 'alert-danger'
            })
        } catch (error) {
          console.error('データの取得に失敗しました:', error)
          this.alertMessage = 'データの取得に失敗しました'
          this.alertClass = 'alert-danger'
        }
      }
    },
    async save_data() {
      try {
        const params = {
          sprm: {
            ...this.formData,
            master_type: 'point_unit',
            stat: this.isEdit ? [1] : [0]
          }
        }

        await this.basicPosts_S(
          config.BASE_API_URL + '/master/save',
          params
        )
          .then(response => {
            if (response.data && response.data.status === 200) {
              this.alertMessage = 'データを保存しました'
              this.alertClass = 'alert-success'
              setTimeout(() => {
                this.go_back()
              }, 1500)
            } else {
              this.alertMessage = 
                response.data.message || 'データの保存に失敗しました'
              this.alertClass = 'alert-danger'
            }
          })
          .catch(error => {
            console.error('データの保存に失敗しました:', error)
            this.alertMessage = 'データの保存に失敗しました'
            this.alertClass = 'alert-danger'
          })
      } catch (error) {
        console.error('データの保存に失敗しました:', error)
        this.alertMessage = 'データの保存に失敗しました'
        this.alertClass = 'alert-danger'
      }
    },
    go_back() {
      this.$router.push('/master/list')
    }
  },
  mounted: function () {
    this.load_data()
  }
}
</script>

<style scoped>
.btn-light.btn-outline-secondary {
  color: #6c757d;
  border-color: #6c757d;
}
.btn-light.btn-outline-secondary:hover {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
</style> 